<script>
import _ from 'lodash'
import ListUtils from '@/utils/list'
import service from '@/request/base'
import NormCaseCommentService from '@/request/databank/NormCaseComment'
import {CommentsItem, ReplyItem} from '@/components/EberComments'
export default {
  name: 'NormcaseCommentsList',
  components: {
    CommentsItem,
    ReplyItem
  },
  props: {
    ncid: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      comments: [],
      editComment: {},
      showEditButton: false
    }
  },
  computed: {},
  created: function () {
    this.listComment()
  },
  watch: {
    ncid () {
      this.listComment()
    }
  },
  methods: {
    listComment () {
      if (!this.ncid) {
        return
      }
      NormCaseCommentService.list({
        ncid: this.ncid
      }).then(data => {
        data = data.result ? data.result : []
        this.comments = ListUtils.listToReply(data, null, 'target', null)
      })
    },
    handleAddCommentReply (item) {
      let self = this
      self.$prompt('', '回复评论', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入内容',
        inputType: 'textarea',
        inputPattern: /\S+/,
        inputErrorMessage: '内容不能为空'
      }).then(({ value }) => {
        NormCaseCommentService.save({
          ncid: self.ncid,
          target: item.id || 0,
          content: value
        }).then(() => {
          self.listComment()
        }, error => {
          self.$message.error(error || '回复失败')
        })
      }).catch(() => {
        self.$message({
          message: '取消操作',
          type: 'info'
        })
      })
    },
    handleClickCommentTool (tool) {
      if (!tool || !tool.name) {
        return
      }
      if (tool.name === 'edit_comment') {
        this.handleEditComment(tool.obj)
      }
      if (tool.name === 'delete_comment') {
        this.deleteComment(tool.obj)
      }
    },
    handleClickReplyTool (tool) {
      if (!tool || !tool.name) {
        return
      }
      if (tool.name === 'delete_reply') {
        this.deleteReply(tool.obj)
      }
    },
    handleEditComment (item) {
      if (!item) {
        return
      }
      let self = this
      self.$prompt('', '修改', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入内容',
        inputType: 'textarea',
        inputValue: item.content,
        inputPattern: /\S+/,
        inputErrorMessage: '内容不能为空'
      }).then(({ value }) => {
        item.content = value
        NormCaseCommentService.save(item).then(() => {
          self.listComment()
        }, error => {
          self.$message.error(error || '修改失败')
        })
      }).catch(() => {
        self.$message({
          message: '取消操作',
          type: 'info'
        })
      })
    },
    submitComment () {
      if (_.isEmpty(this.editComment) || _.isEmpty(this.editComment.content)) {
        this.$alert('评论内容不能为空', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }
      this.editComment.ncid = this.ncid
      NormCaseCommentService.save(this.editComment).then(() => {
        this.$message({
          message: '评论成功',
          type: 'success'
        })
        this.listComment()
        this.editComment = {}
        this.showEditButton = false
      }).catch(error => {
        this.$message.error(error || '评论失败')
      })
    },
    deleteComment (item) {
      if (!item || !item.id) {
        this.$message.error('获取信息失败，请刷新页面重试')
        return
      }
      this.$confirm('确认删除评论吗?', '提示', {type: 'warning'}).then(() => {
        NormCaseCommentService.delete({
          id: item.id
        }).then(() => {
          this.listComment()
          this.$emit('delete-comment')
        }).catch(error => {
          this.$message.error(error || '删除评论失败')
        })
      }, () => {
        this.$message({
          message: '取消操作!',
          type: 'info'
        })
      })
    },
    deleteReply (item) {
      if (!item || !item.id) {
        this.$message.error('获取信息失败，请刷新页面重试')
        return
      }
      this.$confirm('确认删除回复吗?', '提示', {type: 'warning'}).then(() => {
        NormCaseCommentService.delete({
          id: item.id
        }).then(() => {
          this.listComment()
          this.$emit('delete-reply')
        }).catch(error => {
          this.$message.error(error || '删除回复失败')
        })
      }, () => {
        this.$message({
          message: '取消操作!',
          type: 'info'
        })
      })
    },
    tools (item) {
      if (!item) {
        return []
      }
      if (!item.uid || !this.$store.getters.user || this.$store.getters.user.id !== item.uid) {
        return []
      }
      let ts = [{
        name: 'edit_comment',
        icon: 'el-icon-edit-outline',
        title: '修改',
        obj: item
      }, {
        name: 'delete_comment',
        icon: 'el-icon-delete',
        title: '删除',
        style: {
          color: '#F56C6C'
        },
        obj: item
      }]
      return ts
    },
    replyTools (item) {
      if (!item) {
        return []
      }
      if (!item.uid || !this.$store.getters.user || this.$store.getters.user.id !== item.uid) {
        return []
      }
      let ts = [{
        name: 'delete_reply',
        icon: 'el-icon-delete',
        title: '删除',
        style: {
          color: '#F56C6C'
        },
        obj: item
      }]
      return ts
    }
  },
  filters: {
    filterHeadimg (value) {
      if (!value) {
        return null
      }
      if (value && value.indexOf('http') === 0) {
        return value
      }
      value = service.url(value)
      return value
    }
  }
}
</script>

<template>
  <div class="comment-wrap">
    <el-form :model="editComment">
      <el-form-item>
        <el-input type="textarea" :autosize="{ minRows: 2}" placeholder="写下你的评论" v-model="editComment.content" @focus="showEditButton=true"></el-input>
      </el-form-item>
      <el-form-item v-if="showEditButton" style="text-align: right;">
        <el-button round @click="showEditButton = false">取 消</el-button>
        <el-button type="success" round @click="submitComment">发 送</el-button>
      </el-form-item>
    </el-form>
    <div class="comment-title">
      <h3>评论</h3>
    </div>
    <comments-item
      v-for="comment in comments"
      :key="comment.id"
      :avatar="comment.headimg | filterHeadimg"
      :author="comment.uname"
      :content="comment.content"
      :time="comment.time"
      :has-reply="comment.children && comment.children.length > 0"
      :tools="tools(comment)"
      @clickTool="handleClickCommentTool"
      @addReply="handleAddCommentReply(comment)">
      <reply-item
        v-for="reply in comment.children"
        :key="reply.id"
        :author="reply.uname"
        :content="reply.content"
        :time="reply.time"
        :tools="replyTools(reply)"
        @clickTool="handleClickReplyTool"
      ></reply-item>
    </comments-item>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.comment-wrap {
}
.comment-title {
  width: 100%;
  padding: 10px 5px;
  border-bottom: 1px solid #ccc;
}
</style>
